var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"action-button-component bg-color",class:_vm.color,attrs:{"title":_vm.title},on:{"click":function($event){return _vm.actionClick(_vm.name)}}},[_c('i',{staticClass:"fa",class:[ _vm.icon ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }